import React from 'react';
import {TextField, Selector, TagSelector, ColorPicker, TextArea, FormComponent, Timespan} from 'components/core';
import {Grid} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import ReactIs from 'react-is';

const useStyle = makeStyles((theme) => ({
    root:
    {
        minWidth: 400,
        '& .MuiGrid-item':
        {
            width: '100%'
        }
    }
}), {name: "RaymanForm"});

function defaultVal(value: any, defaultValue : any)
{
    if(value === undefined) return defaultValue;
    else return value;
}

interface SelectorItem {
    value: any,
    content: any
}

interface FormField {
    type: string,
    label: string,
    id: string,
    placeholder?: string,
    mandatory?: boolean,
    value?: any,
    items?: SelectorItem[],
    content?: any,
    min?: number,
    max?: number,
    step?: number,
    managed?: boolean
}

interface FormProps {
    onChange(values : {[key: string]: any}): void,
    fields: FormField[],
    values: {[key: string]: any},
    fieldErrors: any, // this should be a [key: string]: string ??
    loading: boolean,
    [props: string]: any
}

interface CustomFieldProps {
    onChange(value : any) : void,
    value: any,
    placeholder? : string,
    error? : string
}

export type {FormField, FormProps, CustomFieldProps, SelectorItem}
export default function Form(props: FormProps)
{
    const classes = useStyle();
    const [internalValues, setInternalValues] = React.useState({});
    const useExternalValues = props.values !== undefined;
    const _values = useExternalValues ? props.values : internalValues;

    React.useEffect(function SetFieldValues(){
        if(useExternalValues) return;
        
        let tmpValues : {[key: string] : any} = {};
        let update = false;
        props.fields.forEach((field : FormField) => {
            if(field.type !== "custom" || field.managed)
            {
                if(tmpValues[field.id] !== field.value)
                {
                    tmpValues[field.id] = field.value;
                    update = true;
                }
            }
        });
        if(update) setInternalValues(tmpValues);
    }, [props.fields, useExternalValues]);

    // React.useEffect(function setManagedValues(){
    //     if(useExternalValues) setInternalValues(values);
    // }, [useExternalValues, values])


    function handleFieldChange(fieldID : string, value : any)
    {
        let tmpValues = {..._values};
        if(tmpValues[fieldID] !== value)
        {
            tmpValues[fieldID] = value;
            if(!useExternalValues) setInternalValues(tmpValues);
            props.onChange(tmpValues);
        }
    }

    

    return <Grid
        container
        direction="column"
        justify="center"
        alignItems="stretch"
        spacing={2}
        className={clsx(classes.root, props.className)}
        >
            {
                props.fields.map((field : FormField) => {
                    let item;
                    switch(field.type)
                    {
                        case "text":
                            item = <TextField value={defaultVal(_values[field.id], "")} disabled={props.loading} key={field.id} label={field.label} placeholder={field.placeholder} error={props.fieldErrors[field.id]} onChange={(evt : any) => handleFieldChange(field.id, evt.target.value)} />;
                            break;
                        case "textarea":
                            item = <TextArea value={defaultVal(_values[field.id], "")} disabled={props.loading} key={field.id} label={field.label} placeholder={field.placeholder} error={props.fieldErrors[field.id]} onChange={(evt : any) => handleFieldChange(field.id, evt.target.value)} />;
                            break;
                        case "number":
                            item = <TextField type="number" min={field.min} max={field.max} step={field.step} value={defaultVal(_values[field.id], "")} disabled={props.loading} key={field.id} label={field.label} placeholder={field.placeholder} error={props.fieldErrors[field.id]} onChange={(evt : any) => handleFieldChange(field.id, evt.target.value)} />;
                            break;
                        case "timespan":
                            item = <Timespan value={defaultVal(_values[field.id], 0)} disabled={props.loading} key={field.id} label={field.label} placeholder={field.placeholder} error={props.fieldErrors[field.id]} onChange={(value : any) => handleFieldChange(field.id, value)} />;
                            break;
                        case "selector":
                            item = <Selector value={defaultVal(_values[field.id], null)} disabled={props.loading} key={field.id} label={field.label} placeholder={field.placeholder} error={props.fieldErrors[field.id]} items={field.items} onChange={(evt : any) => handleFieldChange(field.id, evt.target.value)}/>;
                            break;
                        case "multiselector":
                            item = <Selector multiple value={defaultVal(_values[field.id], [])} disabled={props.loading} key={field.id} label={field.label} placeholder={field.placeholder} error={props.fieldErrors[field.id]} items={field.items} onChange={(evt : any) => handleFieldChange(field.id, evt.target.value)}/>;
                            break;
                        case "tagSelector":
                            item = <TagSelector value={defaultVal(_values[field.id], [])} disabled={props.loading} key={field.id} label={field.label} placeholder={field.placeholder} error={props.fieldErrors[field.id]} items={field.items} onChange={(evt : any) => handleFieldChange(field.id, evt.target.value)}/>;
                            break;
                        case "custom":

                            let customProps : CustomFieldProps = {
                                onChange: (value : any) => handleFieldChange(field.id, value),
                                value: defaultVal(_values[field.id], null),
                                placeholder: field.placeholder,
                                error: props.fieldErrors[field.id]
                            };
                            let contentElement = ReactIs.isFragment(field.content) ? field.content : <field.content {...customProps} />;

                            if(field.label) item = <FormComponent label={field.label} error={props.fieldErrors[field.id] !== undefined}>{contentElement}</FormComponent>
                            else item = contentElement;
                            break;
                        case "colorPicker":
                            item = <ColorPicker value={defaultVal(_values[field.id], "")} disabled={props.loading} key={field.id} label={field.label} error={props.fieldErrors[field.id]} onChange={(value : any) => handleFieldChange(field.id, value)} />
                            break;
                        default:
                            item = `tipo desconocido [${field.id}]: ${field.type}`;
                            break;
                    }

                    return <Grid item key={`grid ${field.id}`}>{item}</Grid>
                })
            }
        </Grid>
}